// src/services/api/npCompliance.js
// API methods for NP compliance features: collaborative agreements,
// transition-to-practice tracking, and chart reviews.

export function createNPComplianceMethods() {
  return {
    // --- Collaborative Agreements ---

    async getCollaborativeAgreements(filters = {}) {
      const params = new URLSearchParams();
      if (filters.organization_id) params.append('organization_id', filters.organization_id);
      if (filters.np_provider_id) params.append('np_provider_id', filters.np_provider_id);
      if (filters.status) params.append('status', filters.status);
      const qStr = params.toString();
      return this.request(`/collaborative-agreement${qStr ? `?${qStr}` : ''}`, { method: 'GET' }, 'getCollaborativeAgreements');
    },

    async createCollaborativeAgreement(data) {
      return this.request('/collaborative-agreement', {
        method: 'POST',
        body: JSON.stringify(data)
      }, 'createCollaborativeAgreement');
    },

    async updateCollaborativeAgreement(id, data) {
      return this.request(`/collaborative-agreement/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data)
      }, 'updateCollaborativeAgreement');
    },

    async deleteCollaborativeAgreement(id) {
      return this.request(`/collaborative-agreement/${id}`, { method: 'DELETE' }, 'deleteCollaborativeAgreement');
    },

    // --- NP Transition Records ---

    async getNPTransitionRecords(filters = {}) {
      const params = new URLSearchParams();
      if (filters.organization_id) params.append('organization_id', filters.organization_id);
      if (filters.provider_id) params.append('provider_id', filters.provider_id);
      if (filters.status) params.append('status', filters.status);
      const qStr = params.toString();
      return this.request(`/np-transition-record${qStr ? `?${qStr}` : ''}`, { method: 'GET' }, 'getNPTransitionRecords');
    },

    async createNPTransitionRecord(data) {
      return this.request('/np-transition-record', {
        method: 'POST',
        body: JSON.stringify(data)
      }, 'createNPTransitionRecord');
    },

    async updateNPTransitionRecord(id, data) {
      return this.request(`/np-transition-record/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data)
      }, 'updateNPTransitionRecord');
    },

    async deleteNPTransitionRecord(id) {
      return this.request(`/np-transition-record/${id}`, { method: 'DELETE' }, 'deleteNPTransitionRecord');
    },

    // --- Chart Reviews ---

    async getChartReviews(filters = {}) {
      const params = new URLSearchParams();
      if (filters.organization_id) params.append('organization_id', filters.organization_id);
      if (filters.reviewer_id) params.append('reviewer_id', filters.reviewer_id);
      if (filters.provider_id) params.append('provider_id', filters.provider_id);
      if (filters.review_type) params.append('review_type', filters.review_type);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      const qStr = params.toString();
      return this.request(`/chart-review${qStr ? `?${qStr}` : ''}`, { method: 'GET' }, 'getChartReviews');
    },

    async createChartReview(data) {
      return this.request('/chart-review', {
        method: 'POST',
        body: JSON.stringify(data)
      }, 'createChartReview');
    },

    async deleteChartReview(id) {
      return this.request(`/chart-review/${id}`, { method: 'DELETE' }, 'deleteChartReview');
    },
  };
}
